import styled from 'styled-components';

export const Bottom = styled.div`
  margin-top: 60px;
  display: flex;
  gap: 8px;
  flex-direction: column;
`;
